import { Parser } from '~/api';
import { SentEmail } from '~/api/models';
import RequestService from './request';

class EmailsService {
    getAll(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/emails', {
            ...req,
            sort: req.sort ?? '-created_at',
            include: ['user'],
        }).then(Parser.parse);
    }

    get(id: string): Promise<SentEmail> {
        return RequestService.get(`/emails/${id}`, { include: ['user'] }).then(Parser.parse);
    }

    getForUser(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/users/:user/emails', {
            ...req,
            sort: req.sort ?? '-created_at',
        }).then(Parser.parse);
    }
}

export default new EmailsService();
